import React from "react";
import Navbar from "../components/Navbar/Navbar";
import UsePageTitle from "../components/UsePageTitle";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useFormik } from "formik";
import { motion } from "framer-motion";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import LogoDark from "../resources/images/LogoDark.svg";
import axios from "axios";

const JoinUs = () => {
  UsePageTitle("Join Us | Bravix Group");
  const { enqueueSnackbar } = useSnackbar();

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      typeOfRoleYouInterestedIn: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      lastName: Yup.string().required("Last name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      phone: Yup.string().required("Phone number is required"),
      typeOfRoleYouInterestedIn: Yup.string().required("Role is required"),
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
      console.log("Form Values before submission:", values);
      try {
        const response = await axios.post(
          "https://bravixgroup.com/api/v1/connect-us",
          values
        );

        console.log("API Response:", response?.data);

        if (!response?.data?.error) {
          enqueueSnackbar(
            response?.data?.message || "Form submitted successfully!",
            { variant: "success" }
          );
          resetForm();
        } else {
          enqueueSnackbar(response?.data?.message || "Something went wrong!", {
            variant: "error",
          });
        }
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message || "Failed to submit the form.";
        enqueueSnackbar(errorMessage, { variant: "error" });
      } finally {
        setSubmitting(false);
      }
    },
  });

  const leftContainerVariant = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const childVariant = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <>
      <Navbar />
      <section className="join_us_section">
        <div className="container h-100">
          <div className="row h-100">
            <div className="react_out_content_main">
              <div className="react_out_content">
                <motion.div
                  className="react_out_content_left"
                  variants={leftContainerVariant}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ amount: 0.3 }}
                >
                  <motion.img
                    src={LogoDark}
                    alt="Logo"
                    initial={{ opacity: 0, scale: 0.8 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ amount: 0.3 }}
                  />
                  <motion.h5 variants={childVariant}>Join the team!</motion.h5>
                  <motion.p variants={childVariant}>
                    We’re always looking to connect with talented individuals
                    looking to make an impact. Reach out to explore
                    opportunities!
                  </motion.p>
                </motion.div>

                <div className="react_out_content_right">
                  <form
                    noValidate
                    onSubmit={formik.handleSubmit}
                    autoComplete="off"
                    method="POST"
                  >
                    <div className="input_main">
                      <div className="input_group">
                        <input
                          type="text"
                          className="form-control"
                          id="firstName"
                          name="firstName"
                          placeholder="First Name"
                          value={formik.values.firstName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.firstName &&
                          formik.errors.firstName && (
                            <div className="error">
                              {formik.errors.firstName}
                            </div>
                          )}
                      </div>
                      <div className="input_group">
                        <input
                          type="text"
                          className="form-control"
                          id="lastName"
                          name="lastName"
                          placeholder="Last Name"
                          value={formik.values.lastName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.lastName && formik.errors.lastName && (
                          <div className="error">{formik.errors.lastName}</div>
                        )}
                      </div>
                    </div>

                    <div className="input_group">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        placeholder="Email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="error">{formik.errors.email}</div>
                      )}
                    </div>

                    <div className="input_group">
                      <PhoneInput
                        id="phone"
                        name="phone"
                        defaultCountry="US"
                        value={formik.values.phone}
                        onChange={(value) =>
                          formik.setFieldValue("phone", value)
                        }
                        placeholder="Phone"
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.phone && formik.errors.phone && (
                        <div className="error">{formik.errors.phone}</div>
                      )}
                    </div>

                    <div className="input_group">
                      <textarea
                        type="text"
                        className="form-control"
                        id="typeOfRoleYouInterestedIn"
                        name="typeOfRoleYouInterestedIn"
                        placeholder="Type of Role you’re interested in"
                        value={formik.values.typeOfRoleYouInterestedIn}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.typeOfRoleYouInterestedIn &&
                        formik.errors.typeOfRoleYouInterestedIn && (
                          <div className="error">
                            {formik.errors.typeOfRoleYouInterestedIn}
                          </div>
                        )}
                    </div>

                    <button type="submit" className="submit_btn">
                      Submit
                    </button>
                  </form>
                  {/* <Link to="/">Go Back</Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default JoinUs;
